export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8530.43ea49c5.jpg";